import logger from './logger';
import { APP_STATE } from 'src/constants/main';
import { hash } from 'src/utils/formatter';
import { debounce, throttle } from 'src/utils/perfomance';

type TListenerParams = {
  event: keyof WindowEventMap;
  callback: () => void;
};
/**
 * Global listeners
 *
 * @class Listener
 */
class Listener {
  private listeners: { [key: string]: TListenerParams } = {};
  /**
   *
   *
   * @param {keyof WindowEventMap} event
   * @param {() => void} callback
   * @param {*} { _debounce = 0, _throttle = 0 }
   * @memberof Listener
   */
  addListener = (event: keyof WindowEventMap, callback: () => void, { _debounce = 0, _throttle = 0 }): string => {
    const key = hash(Date.toString());

    if (_debounce) {
      this.listeners[key] = {
        event,
        callback: debounce(callback, _debounce),
      };
    } else if (_throttle) {
      this.listeners[key] = {
        event,
        callback: throttle(callback, _throttle),
      };
    } else {
      this.listeners[key] = {
        event,
        callback,
      };
    }

    window.addEventListener(event, this.listeners[key].callback);
    return key;
  };

  /**
   *
   *
   * @param {string} key
   * @memberof Listener
   */
  removeListener = (key: string) => {
    const _listener: TListenerParams = this.listeners[key];
    if (!_listener) return;
    window.removeEventListener(_listener.event, _listener.callback);
    // remove from listeners
    delete this.listeners[key];
  };
  /**
   * Function will be called just from RN wrapper if app sttate was changed
   * We should call all listeners which added on window focus/blur
   *
   * @param {APP_STATE} state is app focused/blured now
   * @memberof Listener
   */
  public appStateChange(state: APP_STATE) {
    logger.log('APPP STATE CHANGERR LISTENERS');
    if (state === APP_STATE.OPENED) {
      Object.values(this.listeners)
        .filter((param) => param.event === 'focus')
        .forEach((param) => param.callback());
    } else if (state === APP_STATE.CLOSED) {
      Object.values(this.listeners)
        .filter((param) => param.event === 'blur')
        .forEach((param) => param.callback());
    }
  }
}

const listener = new Listener();

export default listener;
